import {Box, Checkbox, FormControlLabel, Slider, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {capitalize} from 'lodash-es';
import {ErrorPage} from '../../../pages/ErrorPage';
import Loading from '../../../components/Loading/Loading';
import {UPDATES} from '../../../shared/UPDATES';
import {GoalFormValues, GoalPartProps} from './utils';
import useStatusPriority from './useStatusPriority';
import {setGoalPriorityMarkers} from './GoalPrioritiesHelper';
// import {setGoalPriorityMarkers, setGoalStatusMarkers} from './GoalPrioritiesHelper';
import {StatusAtReviewEnum} from '../../../schema-types/globalTypes';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';

export const StatusAtReviewEnumOrder: StatusAtReviewEnum[] = [
  StatusAtReviewEnum.UNDEFINED,
  StatusAtReviewEnum.BEHIND_TARGET,
  StatusAtReviewEnum.ON_TARGET,
  StatusAtReviewEnum.AHEAD_OF_TARGET,
  StatusAtReviewEnum.SATISFIED,
];

export default function GoalPriorities(props: GoalPartProps) {
  const {values, setFieldValue} = useAutoForm<GoalFormValues>();
  // const [statusAtReviewMarkLabels, setStatusAtReviewMarkLabels] = useState<
  //   StatusAtReviewEnum[]
  // >([]);
  const [priorityMarkLabels, setPriorityMarkLabels] = useState<string[]>([]);
  // this is annoying but we need to use numbers to track where we are on the slider :(
  const [priorityIndex, setPriorityIndex] = useState(0);
  const [statusAtReviewIndex, setStatusAtReviewIndex] = useState(
    StatusAtReviewEnumOrder.findIndex((x) => x === values.statusAtReview) || 0
  );
  const {
    statusData,
    priorityData,
    statusLoading,
    statusError,
    priorityLoading,
    priorityError,
  } = useStatusPriority();

  const setStatus = (index: number) => {
    setStatusAtReviewIndex(index);
    setFieldValue(
      UPDATES._1111,
      'statusAtReview',
      index > 0 ? StatusAtReviewEnumOrder[index] : null
    );
  };

  const setPriority = (index: number) => {
    setPriorityIndex(index);
    setFieldValue(
      UPDATES._1112,
      'priority',
      index > 0 ? priorityMarkLabels[index] : null
    );
  };

  // useEffect(() => {
  //   setGoalStatusMarkers({
  //     statusData,
  //     setStatusAtReviewMarkLabels,
  //     values,
  //     setStatusAtReviewIndex,
  //   });
  // }, [statusData.length]);

  useEffect(() => {
    setGoalPriorityMarkers({
      priorityData,
      setPriorityMarkLabels,
      values,
      setPriorityIndex,
    });
  }, [priorityData.length]);

  if (statusLoading || priorityLoading) {
    return <Loading />;
  }

  if (statusError || priorityError) {
    return (
      <ErrorPage
        code="Server Error"
        text="We were unable to retrieve the account information."
      />
    );
  }

  return (
    <Box mt={3} mx={5}>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              key={`${values.statusAtReview}`}
              checked={values.statusAtReview === StatusAtReviewEnum.NO_LONGER_REQUIRED}
              onChange={() => {
                if (values.statusAtReview !== StatusAtReviewEnum.NO_LONGER_REQUIRED) {
                  setFieldValue(
                    UPDATES._1111,
                    'statusAtReview',
                    StatusAtReviewEnum.NO_LONGER_REQUIRED
                  );
                  // doesn't make sense to have a priority if the goal is no longer required
                  setFieldValue(UPDATES._1112, 'priority', null);
                }
              }}
              name="no-longer"
            />
          }
          label="No longer required"
        />
      </Box>
      <Box mt={5}>
        <Typography variant="h6">Status:</Typography>
        <Slider
          disabled={values.statusAtReview === StatusAtReviewEnum.NO_LONGER_REQUIRED}
          value={statusAtReviewIndex}
          onChange={(_, v) => setStatus(+v)}
          min={0}
          max={StatusAtReviewEnumOrder.length}
          marks={StatusAtReviewEnumOrder.map((name, index) => ({
            label: capitalize(name.toLocaleLowerCase()).replaceAll('_', ' '),
            value: index,
          }))}
        />
      </Box>
      <Box mt={10}>
        <Typography variant="h6">Priority:</Typography>
        <Slider
          disabled={values.statusAtReview === StatusAtReviewEnum.NO_LONGER_REQUIRED}
          value={priorityIndex}
          onChange={(_, v) => setPriority(+v)}
          min={0}
          max={priorityMarkLabels.length - 1}
          marks={Array.from({length: priorityMarkLabels.length}, (v, k) => {
            return {
              label: k === 0 ? priorityMarkLabels[k] : priorityMarkLabels[k].substring(4),
              value: k,
            };
          })}
        />
      </Box>
    </Box>
  );
}
